import {Component, Prop, Vue} from 'vue-property-decorator'
import {UserProfile} from "@api/models/UserProfile";
import {Participant} from "@api/models/meetings/Participant";

@Component
class UserMixin extends Vue {
    @Prop() user: UserProfile | Participant;
    @Prop({ default: 32, required: false }) iconSize: number;
    @Prop({ default: false, required: false }) showCompanyAndPosition: boolean;
    backend: string;

    get profilePhotoLink() {
        return this.iconSize < 88 ? this.user.profilePhotoLink(this.backend) : this.user.profilePhotoLink(this.backend, this.iconSize);
    }

    get profileColor() {
        return this.user.profileColor;
    }

    get job(): string {
        return [this.company, this.user.position].filter(item => item).join(', ');
    }

    get company(): string {
        return this.user.company || this.user.direction
    }

    created() {
        this.backend = this.$store.state.session.backend;
    }

    get firstEntranceStatus() {
        if (this.user) {
            return this.user.firstEntranceStatus ||  false;
        }
        return false;
    }
}

export default UserMixin